import Tr from 'translations/Translations';

const createItem = (trKey, value = Tr(trKey)) => ({
	label: Tr(trKey),
	value,
})

export const POSITION_VALUE = {
	// DEFAULT: '1',
	// OTHER: '6',

	CHAIRMAN: 'CHAIRMAN',
	VICECHAIRMAN: 'VICECHAIRMAN',
	SECRETARY: 'SECRETARY',
	VICESECRETARY: 'VICESECRETARY',
	SUPERVISOR: 'SUPERVISOR',
	MEMBER: 'MEMBER',
	BUYER_SUPERVISOR: 'BUYER_SUPERVISOR',
	EXPERT: 'EXPERT',
	OTHER: 'OTHER'
}

export default [
	createItem('position_1', POSITION_VALUE.CHAIRMAN),
	createItem('position_2', POSITION_VALUE.VICECHAIRMAN),
	createItem('position_3', POSITION_VALUE.SECRETARY),
	createItem('position_3a', POSITION_VALUE.VICESECRETARY),
	createItem('position_3b', POSITION_VALUE.SUPERVISOR),
	createItem('position_4', POSITION_VALUE.MEMBER),
	createItem('position_4a', POSITION_VALUE.BUYER_SUPERVISOR),
	createItem('position_5', POSITION_VALUE.EXPERT),
	createItem('position_6', POSITION_VALUE.OTHER),
]